//import { CONTACTS_DEFAULT_END, CONTACTS_DEFAULT_START } from '../conf/mtma-contacts';
import { MtmaUnit } from './mtma-unit';

export class MtmaContact {
    Id?: number;
    Actions: number[];
    Description: string;
    Name: string;
    ObjId: string;
    Phone: string;
    rowExpanded: boolean;
    Units: MtmaUnit[];
    RuleId: number;
    DtFrom: string;
    DtTo: string;

    constructor() {
        //this.DtFrom = CONTACTS_DEFAULT_START;
        //this.DtTo = CONTACTS_DEFAULT_END;
        this.Actions = [255, 255];
    }
}
